module.exports = __webpack_public_path__ + "img/aqua2.51b03317.png";